<style lang="css">
@import 'vue-multiselect/dist/vue-multiselect.min.css';
</style>
<template>

   <div class="cl-search_filter">
              <h3 class="cl-search_filter_title">{{filter.label}}</h3>  
              <multiselect v-model="selectedFacets" :options="optionList" :multiple="true" :preserve-search="true"  :clear-on-select="false" open-direction="bottom" :close-on-select="false" :options-limit="300" 
               @input="dispatchAction" :limit="2" :show-labels="false" >
              
            <!--  <div class="multiselect__clear" v-if="selectedFacets.length>0" @mousedown.prevent.stop="clearAll()"></div>-->
               <template slot="option" slot-scope="{option}"><span class="custom__tag"><span>{{ option }}</span></span></template>
   <template slot="clear" slot-scope="props">
      <div class="multiselect__clear" v-if="selectedFacets.length" @click.prevent.stop="clearAll()" v-b-tooltip.hover title="Clear all"></div>
    </template>
              </multiselect>
  </div>
  
</template>
<script>

import Multiselect from 'vue-multiselect'
 
export default {
  name: 'multiselect-filter',
  components: { Multiselect },
  props: {
    filter: {
      type: Object,
      default:{}
    },
    facetSelection:{
      type: Array,
      default: () => []
    }
  },
  data () {
      return {
        selectedFacets: []
      }
    },
  mounted(){
    this.options = this.filter.values.slice(0);
    this.facetSelection.forEach((felem) => {
      if(felem.field === this.filter.filtertype && felem.type === this.filter.filterparent){
        this.selectedFacets=felem.terms.slice();
        console.log(this.selectedFacets); 
      }
    })
    
    
  },
  computed:{
     optionList: function () {
       return this.filter.values;
     }

  },
   methods: {
    clearAll () {
      this.selectedFacets = [];
      var event = new CustomEvent("filterClear", {
        detail: {
          filtertype: this.filter.filtertype,
          filterparent: this.filter.filterparent
        }
      });
      this.$emit('filterClear',event);
    },
    dispatchAction(val){
      
      var event = new CustomEvent("filterUpdate", {
        detail: {
          filtertype: this.filter.filtertype,
          filterparent: this.filter.filterparent,
          newvalue: val
        }
      });
      
      this.$emit('filterUpdate',event);
    }
  }
}
</script>
<!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->
<style>

.multiselect__content-wrapper {
    position: relative;
}

.multiselect__option--highlight {
    background: #EE861D;
}

.multiselect, .multiselect__input, .multiselect__single {
     font-size: 13px;
}
.multiselect__clear {
    position: absolute;
    right: 2.5em;
    top: 0.5em;
    width: 10px;
    display: block;
    cursor: pointer;
    z-index: 2;
    background:white;
}
.multiselect__clear::before {
    transform: rotate(45deg);
}
.multiselect__clear::after {
    transform: rotate(-45deg);
}
.multiselect__clear::after, .multiselect__clear::before {
    content: "";
    display: block;
    position: absolute;
    width: 3px;
    height: 12px;
    background: red;
    top: 10px;
    right: 4px;
}
.multiselect__tag {
    background: #EE861D;
    margin-top:5px;
    max-width: 90%;
}

.multiselect__tag-icon:after{
   color: white;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
    background: lightgrey;
   
}

.multiselect__placeholder {
      padding: 5px 0 0 5px;
}

.multiselect__strong {
    line-height: unset;
}
</style>



// WEBPACK FOOTER //
// src/plugins/SearchPlugin/components/FilterMultiselect.vue